<template>
  <div class="map">
    <div class="content">
      <ul class="contacts">
        <li v-for="(contact, cityCode) in contacts" :key="cityCode" :class="{'active' : cityCode === currentCityCode}">
          <h2 @click="currentCityCode=cityCode">{{ contact.title }}</h2>
          <div v-if="cityCode === currentCityCode">
            <div class="contact-data" v-for="item in contact.items" :key="item.uid" >
              <div>{{ item.address }}</div>
              <div>{{ item.phone }}</div>
              <div>{{ item.email }}</div>
            </div>
          </div>
        </li>
      </ul>
      <img src="/cloudmill/images/map_carbon_default.svg" v-if="!currentCityCode" class="points" alt=""/>
      <img :src="'/cloudmill/images/map_carbon_'+ currentCityCode +'.svg'" v-if="currentCityCode" class="points"   />
      <img src="/cloudmill/images/map_carbon.svg" class="base" alt=""/>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfficeMap",
  props: ['contacts'],
  data () {
    return {
      currentCityCode: null
    }
  }
}
</script>

<style scoped>
@media (max-width: 950px) {
  .contacts {
    position: relative!important;
  }
}

@media (max-width: 1500px) {
  .contacts {
    li {
      h2 {
        font-size: 120%!important;
        cursor: pointer;
        margin: 20px 0;
      }

      &.active {
        h2 {
          font-size: 140%!important;
          color: #ff570f;
        }
      }

    }
  }
}

.map {
  background: #e0e1e3;
}

.contacts {
  margin-left: -10px;
  position: absolute;
  margin-top: 30px;
  z-index: 1000;

  .contact-data {
    line-height: 1.2;
    margin-left: 10px;
    max-width: 250px;
  }

  li {
    h2 {
      font-size: 180%;
      cursor: pointer;
      margin: 20px 0;
    }

    &.active {
      h2 {
        font-size: 240%;
        color: #ff570f;
      }
    }

  }
}

.map {
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;

  .content {
    border-left: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
    position: relative;
  }

  .points {
    height: auto;
    width: 100%;
    position: absolute;
  }

  .base {
    height: auto;
    width: 100%;
  }
}
</style>